var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('span',{staticClass:"px-2"},[_vm._v("Accommodation: "+_vm._s(this.hspt.huis_code)+" ")]),_c('span',{staticClass:"px-2"},[_vm._v("Status: "+_vm._s(this.hspt.stat_code)+" ")]),_c('span',{staticClass:"px-10"},[_vm._v("Arrival: "+_vm._s(this.hspt.hspt_aank_van_dat)+" - "+_vm._s(this.hspt.hspt_aank_tm_dat)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }